import { Navigate, type RouteObject } from 'react-router';

import { ConnectWithSeek } from './pages/ConnectWithSeek/ConnectWithSeek';
import { ConnectedPartners } from './pages/ConnectedPartners/ConnectedPartners';
import { IntegrationRequest } from './pages/IntegrationRequest/IntegrationRequest';
import { LinkYourSoftware } from './pages/LinkYourSoftware/LinkYourSoftware';
import { ReleaseNotes } from './pages/ReleaseNotes/ReleaseNotes';
import { TermsOfUse } from './pages/TermsOfUse/TermsOfUse';
import { ApplyWithSeek } from './pages/WhatsPossible/pages/ApplyWithSeek/ApplyWithSeek';
import { JobPosting } from './pages/WhatsPossible/pages/JobPosting/JobPosting';
import { OptimisedApply } from './pages/WhatsPossible/pages/OptimisedApply/OptimisedApply';
import { TalentSearchConnect } from './pages/WhatsPossible/pages/TalentSearchConnect/TalentSearchConnect';
import { useQuery } from './utils/hooks/useQuery';

const NavigateReplaceWithVersion = ({ to }: { to: string }) => {
  const version = useQuery().get('v');
  return (
    <Navigate
      to={{ pathname: to, ...(version ? { search: `?v=${version}` } : {}) }}
      replace
    />
  );
};

export const whatsPossibleLinks = [
  {
    slug: 'seek-job-posting',
    path: '/whats-possible/seek-job-posting',
    name: 'SEEK Job Posting',
    element: <JobPosting />,
  },
  {
    slug: 'seek-optimised-apply',
    path: '/whats-possible/seek-optimised-apply',
    name: 'SEEK Optimised Apply',
    element: <OptimisedApply />,
  },
  {
    slug: 'apply-with-seek',
    path: '/whats-possible/apply-with-seek',
    name: 'Apply with SEEK',
    element: <ApplyWithSeek />,
  },
  {
    slug: 'talent-search-connect',
    path: '/whats-possible/talent-search-connect',
    name: 'Talent Search Connect',
    element: <TalentSearchConnect />,
  },
];

export const routes: RouteObject[] = [
  {
    path: '',
    element: <NavigateReplaceWithVersion to="/connect-with-seek" />,
  },
  {
    path: 'link-your-software',
    element: <LinkYourSoftware slug="Link your software" />,
  },
  {
    path: 'connect-with-seek',
    element: <ConnectWithSeek slug="Connect with Seek" />,
  },
  {
    path: 'connected-partners',
    element: <ConnectedPartners slug="Connected Partners" />,
  },
  {
    path: 'release-notes',
    element: <ReleaseNotes slug="Release Notes" />,
  },
  {
    path: 'partner-with-seek',
    element: <NavigateReplaceWithVersion to="/connect-with-seek" />,
  },
  {
    path: 'integration-request',
    element: <IntegrationRequest slug="Integration Request" />,
  },
  {
    path: 'terms-of-use',
    element: <TermsOfUse slug="Terms of Use" />,
  },
  {
    path: 'whats-possible',
    children: [
      {
        index: true,
        element: <NavigateReplaceWithVersion to="seek-job-posting" />,
      },
      ...whatsPossibleLinks,
    ],
  },
  {
    path: 'integrations',
    element: <NavigateReplaceWithVersion to="/whats-possible" />,
  },
  ...whatsPossibleLinks.map(({ slug }) => ({
    path: `/integrations/${slug}`,
    element: <NavigateReplaceWithVersion to={`/whats-possible/${slug}`} />,
  })),
];
